var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTakes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_set"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon_vector",
    d: "M7.99331 1.33337C4.31331 1.33337 1.33331 4.32004 1.33331 8.00004C1.33331 11.68 4.31331 14.6667 7.99331 14.6667C11.68 14.6667 14.6666 11.68 14.6666 8.00004C14.6666 4.32004 11.68 1.33337 7.99331 1.33337ZM7.99998 13.3334C5.05331 13.3334 2.66665 10.9467 2.66665 8.00004C2.66665 5.05337 5.05331 2.66671 7.99998 2.66671C10.9466 2.66671 13.3333 5.05337 13.3333 8.00004C13.3333 10.9467 10.9466 13.3334 7.99998 13.3334ZM8.33331 4.66671H7.33331V8.66671L10.8333 10.7667L11.3333 9.94671L8.33331 8.16671V4.66671Z",
    fill: "#C3C3C3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTakes);
export default __webpack_public_path__ + "static/media/ic_takes.80a5e68b8f5709c09f1200517695f531.svg";
export { ForwardRef as ReactComponent };